import { createContext, useContext } from 'react'

/**
 * Indicates where the record cell edit details are being displayed from. This is used to determine
 * whether to use a popover or not in the lookup cell edit. If the origin is TABLE_DETAILS, then the
 * edit component is already inside of a popover so we don't need to add a 2nd popover for the
 * lookup edit. This is also used to determine if the number text input should be right or left
 * aligned and if the multiselect dropdown should remain open after user selection
 */
export enum RecordCellEditOrigin {
  // A form dialog
  FORM = 'FORM',
  // The record create dialog
  RECORD_CREATE = 'RECORD_CREATE',
  // The full record details page
  RECORD_DETAILS = 'RECORD_DETAILS',
  // The full table details page
  TABLE_DETAILS = 'TABLE_DETAILS',
}

export const EditableTableCellOriginContext = createContext<RecordCellEditOrigin | null>(null)

export interface EditableTableCellOriginProviderProps {
  origin: RecordCellEditOrigin
  children: React.ReactNode
}

export function EditableTableCellOriginProvider({
  origin,
  children,
}: EditableTableCellOriginProviderProps) {
  return (
    <EditableTableCellOriginContext.Provider value={origin}>
      {children}
    </EditableTableCellOriginContext.Provider>
  )
}

/**
 * Hook to get the EditableTableCellOriginContext value which contains the origin of the field
 */
export const useEditableTableCellOriginContext = () => {
  const context = useContext(EditableTableCellOriginContext)

  return context
}
